

exports.__esModule = true;
exports.$SidepageRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

var _route = require('xo-wallet-components/src/topup/topup-amount/route');

var _route2 = _interopRequireDefault(_route);

var _route3 = require('xo-wallet-components/src/topup/topup-funding/route');

var _route4 = _interopRequireDefault(_route3);

var _route5 = require('xo-wallet-components/src/topup/update-pin/route');

var _route6 = _interopRequireDefault(_route5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $SidepageRoute = exports.$SidepageRoute = _index.$Route.extend('$SidepageRoute', {

    path: 'sidepage',
    directive: _directive2['default'],
    children: [{
        route: _route4['default'],
        props: function props() {
            return {
                token: this.token,
                success: this.actions.done
            };
        }
    }, {
        route: _route2['default'],
        props: function props() {
            return {
                token: this.token,
                success: this.actions.done
            };
        }
    }, {
        route: _route6['default'],
        props: function props() {
            return {
                token: this.token,
                success: this.actions.done
            };
        }
    }]
});

angular.value("$SidepageRoute", $SidepageRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidepage/route.js
// module id = ./pages/xo-sidepage/route.js
// module chunks = 0